import React from 'react';

import { AZURE_CONNECTOR_FIELDS } from '../../common/fields';
import { AD_CONNECTOR_TYPE } from '@silverfort-nodelibs/common/utils/consts';
import Button from '../Controls/Button/Button';
import TextInput from '../Controls/TextInput/TextInput';

import styles from './AzureConnector.module.css';
import { httpGet, httpPost } from '../../../utils';

const AzureConnector = ({ azureConnector, changedFunc, authorizePermission }) => {
    const applicationId = azureConnector[AZURE_CONNECTOR_FIELDS.APPLICATION_ID.ID];
    const clientSecret = azureConnector[AZURE_CONNECTOR_FIELDS.CLIENT_SECRET.ID];
    const hasClientSecret = azureConnector[AZURE_CONNECTOR_FIELDS.HAS_CLIENT_SECRET.ID];
    const accessToken = azureConnector[AZURE_CONNECTOR_FIELDS.ACCESS_TOKEN.ID];
    const type = azureConnector[AZURE_CONNECTOR_FIELDS.TYPE.ID];
    const authorized = azureConnector[AZURE_CONNECTOR_FIELDS.AUTHORIZED.ID];

    const authorize = async () => {
        try {
            const { data: generateResponse } = await httpPost('/Settings/generateAADAccessToken', {
                applicationID: applicationId.value,
                clientSecret: clientSecret.value,
                type: type.value
            });

            if (!generateResponse.url) {
                throw new Error('Failed to generate URL');
            }

            window.open(generateResponse.url);
            const { data: authResponse } = await httpGet('/Settings/getAADAccessTokenResponse');
            if (!authResponse) {
                throw new Error('Failed to get Auth Response');
            }

            changedFunc(AZURE_CONNECTOR_FIELDS.ACCESS_TOKEN.ID, authResponse.accessToken);
            changedFunc(AZURE_CONNECTOR_FIELDS.REFRESH_TOKEN.ID, authResponse.refreshToken);
            changedFunc(AZURE_CONNECTOR_FIELDS.TENANT_ID.ID, authResponse.tenantID);
            changedFunc(AZURE_CONNECTOR_FIELDS.AUTHORIZED.ID, true);
        } catch (error) {
            console.error('Failed to authorize application', error);
        }
    };

    const renderAuthorizeButton = () => {
        return (
            <div>
                <Button disabled={!authorizePermission} onClick={authorize}>
                    {authorized.value ? 'Reauthorize' : 'Authorize'}
                </Button>
            </div>
        );
    };

    return (
        <>
            {type.value === AD_CONNECTOR_TYPE.APPLICATION && (
                <div className={styles.azureConnector}>
                    <TextInput field={applicationId} color="grey" changed={changedFunc} />
                    <TextInput
                        field={clientSecret}
                        placeholder={hasClientSecret.value ? '******' : ''}
                        type="password"
                        color="grey"
                        changed={changedFunc}
                        errorPadding={applicationId.error}
                        notificationPadding={applicationId.notification}
                    />
                    {renderAuthorizeButton()}
                    {accessToken && accessToken.notification && (
                        <div className={styles.notificationText}>{accessToken.notification}</div>
                    )}
                </div>
            )}
        </>
    );
};

export default React.memo(AzureConnector);
